import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { deepCopy } from 'src/app/common/utilities/copy.helpers';
import { select } from 'src/app/common/utilities/ngxs-utils';
import { PlansService } from '../../shared/services/plans/plans.service';
import { FetchPlanDetails } from '../../shared/state/implementation-plan/implementation-plan.actions';
import {
  ImplementationPlanState,
  PlanDetailsItemStateModel,
} from '../../shared/state/implementation-plan/implementation-plan.state';
import {
  PlanDashboardItemAPIResponse,
  PlanDetailsItemAPIResponse,
} from '../../shared/types/responses/plan.responses';
import { checkIfPlanEditor } from '../plans-page/plans-page-helpers';

@Component({
  selector: 'app-implementation-plan-page',
  templateUrl: './implementation-plan-page.component.html',
  styleUrl: './implementation-plan-page.component.scss',
  standalone: false,
})
export class ImplementationPlanPageComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  planId: number;

  planDashboardInfo: PlanDashboardItemAPIResponse;

  planDetails$: Observable<PlanDetailsItemStateModel> = select(
    ImplementationPlanState.getPlanDetails
  );

  planDetails: PlanDetailsItemAPIResponse;

  forbidden = false;

  user: User | null = null;

  planEditor = false;

  constructor(
    private route: ActivatedRoute,
    private plansService: PlansService,
    private store: Store
  ) {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.params.subscribe((params) => {
        if (params['planId']) {
          this.planId = parseInt(params['planId']);
          this.store.dispatch(new FetchPlanDetails(this.planId));
          this.planDetails$.subscribe((details) => {
            if (details) {
              this.planDetails = deepCopy(details);
              if (this.user) {
                this.planEditor = checkIfPlanEditor(this.user, this.planDetails);
              }
            }
          });
          this.plansService.getPlanDashboard(this.planId).subscribe({
            error: (error) => {
              if (error.status === 403) {
                this.forbidden = true;
              }
            },
            next: (details) => {
              if (details.item) {
                this.planDashboardInfo = details.item;
                this.planDashboardInfo.start_date = this.formatDate(
                  this.planDashboardInfo.start_date
                );
                this.planDashboardInfo.end_date = this.formatDate(
                  this.planDashboardInfo.end_date
                );
              }
            },
          });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /* eslint-disable-next-line class-methods-use-this */
  formatDate(date: string) {
    // date comes in YYYY-MM-DD format
    const dates = date.split('-');
    return `${dates[1]}/${dates[2]}/${dates[0]}`;
  }
}
